export enum ReminderFilterOption {
    All = 0,
    Past = 1,
    Future = 2
}
// completed
// Igonore

export enum ReminderStatus {
    Pending = 1,
    Completed = 101,
    Ignored = 102
}